var _path, _path2, _g, _g2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M600 10c325 0 590 266 590 590 0 325-265 590-590 590S10 925 10 600C10 276 275 10 600 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "nonzero",
    d: "M600 20V0zm600 580h-20l-1-30-2-29-4-29-5-28-6-28-8-28-9-27-11-26-11-26-13-25-14-24-15-24-17-22-17-22-18-21-19-21-21-19-21-18-22-17-22-17-24-15-24-14-25-13-26-11-26-11-27-9-27-8-28-6-29-5-29-4-29-2-30-1V0l31 1 30 2 30 4 30 5 29 7 28 8 28 10 27 10 27 12 25 14 26 14 24 16 23 17 23 17 22 19 21 20 20 21 19 22 17 23 17 23 16 24 14 26 14 25 12 27 10 27 10 28 8 29 7 28 5 30 4 30 2 30zm-10 0h10zm-590 600v-20l30-1 29-2 29-4 29-5 28-6 27-8 27-9 26-11 26-11 25-13 24-14 24-15 22-17 22-17 21-18 21-19 19-21 18-21 17-22 17-22 15-24 14-24 13-25 11-26 11-26 9-27 8-27 6-28 5-29 4-29 2-29 1-30h20l-1 31-2 30-4 30-5 30-7 29-8 28-10 28-10 27-12 27-14 25-14 26-16 24-17 23-17 23-19 22-20 21-21 20-22 19-23 17-23 17-24 16-26 14-25 14-27 12-27 10-28 10-28 8-29 7-30 5-30 4-30 2zm0-20v20zM0 600h20l1 30 2 29 4 29 5 29 6 28 8 27 9 27 11 26 11 26 13 25 14 24 15 24 17 22 17 22 18 21 19 21 21 19 21 18 22 17 22 17 24 15 24 14 25 13 26 11 26 11 27 9 27 8 28 6 29 5 29 4 29 2 30 1v20l-31-1-30-2-30-4-30-5-28-7-29-8-28-10-27-10-27-12-25-14-26-14-24-16-23-17-23-17-22-19-21-20-20-21-19-22-17-23-17-23-16-24-14-26-14-25-12-27-10-27-10-28-8-28-7-29-5-30-4-30-2-30zm10 0H0zM600 0v20l-30 1-29 2-29 4-29 5-28 6-27 8-27 9-26 11-26 11-25 13-24 14-24 15-22 17-22 17-21 18-21 19-19 21-18 21-17 22-17 22-15 24-14 24-13 25-11 26-11 26-9 27-8 28-6 28-5 28-4 29-2 29-1 30H0l1-31 2-30 4-30 5-30 7-28 8-29 10-28 10-27 12-27 14-25 14-26 16-24 17-23 17-23 19-22 20-21 21-20 22-19 23-17 23-17 24-16 26-14 25-14 27-12 27-10 28-10 29-8 28-7 30-5 30-4 30-2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "inherit",
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 39.871
  }, /*#__PURE__*/React.createElement("path", {
    d: "M600 71v81m0 896v81M152 600H71M1129 600h-81"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "inherit",
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 19.936
  }, /*#__PURE__*/React.createElement("path", {
    d: "m376 212-41-70M865 1058l-41-70M212 376l-70-40M1058 865l-70-41M212 824l-70 41M1058 336l-70 40M376 988l-41 70M865 142l-41 70"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00BF63",
    fillRule: "nonzero",
    d: "M606 576c14 4 22 17 18 31-4 13-17 21-30 17zm-255-69 255 69-12 48-256-70zm-13 47c-13-3-21-17-17-30 3-13 17-21 30-17z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00BF63",
    fillRule: "nonzero",
    d: "M585 600c0-9 7-15 15-15s15 7 15 15zm-1 391 1-391h30l-1 391zm30 0c0 8-7 15-15 15-9 0-15-7-15-15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.f740d1f3972fa299cbab211cf4909fd1.svg";
export { ForwardRef as ReactComponent };